import { Asset } from "@hydrologiq/gql-experience/graphql"
import { Box } from "@chakra-ui/react"
import AssetHeadlineFigures from "./AssetHeadlineFigures"
import { DateTime, utc } from "timezonecomplete"

const AssetFigures = ({
  asset,
  onMonitoringStatusChange,
}: {
  asset?: Asset
  onMonitoringStatusChange?: () => void
}) => {
  const latestAssignment = asset?.assignments?.all?.find((assignment) => assignment.id === asset?.assignments?.latest)

  return (
    <Box width="100%" display="flex" flexDirection="column">
      <AssetHeadlineFigures
        asset={asset}
        stop={latestAssignment?.end ? new DateTime(latestAssignment.end, utc()) : undefined}
        mode="overview"
        onMonitoringStatusChange={onMonitoringStatusChange}
      />
    </Box>
  )
}

export default AssetFigures
